import { render, staticRenderFns } from "./ImageVertical.vue?vue&type=template&id=5e283c0c&scoped=true&lang=pug&"
import script from "./ImageVertical.vue?vue&type=script&lang=ts&"
export * from "./ImageVertical.vue?vue&type=script&lang=ts&"
import style0 from "./ImageVertical.vue?vue&type=style&index=0&id=5e283c0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e283c0c",
  null
  
)

export default component.exports